import { $CombinedState } from 'redux';
import LazyHelper from '../helpers/lazy-helper';

const InitPardomForm = {
    init: function () {
        document.addEventListener("DOMContentLoaded", function () {
            let pardomFormJsUrl = '/Mvc/Scripts/PardotForm/pardotform.min.js';
            let jqueryScriptUrl = '/Scripts/libs/jquery.min.js';
            let frameResizerUrl = 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.3/iframeResizer.min.js';
            let frameResizer;
            let frameresizerLoaded = true;

            if ('undefined' == typeof window.jQuery) {
                if (!LazyHelper.doesScriptExists(jqueryScriptUrl)) {
                    LazyHelper.addScriptFile(jqueryScriptUrl, 'jquery', false, false);
                }
            }

            LazyHelper.waitJqueryToLoad(function () {
                if (!LazyHelper.doesScriptExists(frameResizerUrl)) {
                    frameresizerLoaded = false;
                    frameResizer = LazyHelper.addScriptFile(frameResizerUrl, 'frameresizer', false, false);
                    frameResizer.onload = function () {
                        frameresizerLoaded = true;
                        var pardotForm = document.querySelector('iframe[id^="PardotForm"].auto-resize');
                        if (pardotForm !== null) {
                            iFrameResize({ autoResize: true, checkOrigin: false }, 'iframe');
                        }
                    }
                }
            });

            let fancyBox = document.getElementsByClassName('js-fancybox');
            let isJsLoaded = false;
            for (let index = 0; index < fancyBox.length; index++) {
                let element = fancyBox[index];
                element.onclick = function () {
                    loadPardotForm(element);
                    element.addEventListener("click", function () {
                        if (element.classList.contains("auto-resize")) {
                            $(this).fancybox({
                                beforeShow: function () {
                                    iFrameResize({ autoResize: true, checkOrigin: false }, '.fancybox-iframe')
                                    $('.fancybox-inner').addClass('full-height');
                                }
                            });
                        }
                    });
                    return false;
                };
            }


            function loadPardotForm(clickedElement) {
                if (isJsLoaded) {
                    return;
                }

                isJsLoaded = true;
                let jqueryFancyBoxJsUrl = '/Scripts/libs/fancybox.min.js';
                let jqueryFancyBoxCssUrl = '/Scripts/libs/fancybox.min.css';

                LazyHelper.addCssFile(jqueryFancyBoxCssUrl, true);

                LazyHelper.waitJqueryToLoad(function () {
                    let fancyBox;
                    let fancyboxLoaded = true;
                    if (!LazyHelper.doesScriptExists(jqueryFancyBoxJsUrl)) {
                        fancyboxLoaded = false;
                        fancyBox = LazyHelper.addScriptFile(jqueryFancyBoxJsUrl, 'jquery-fancybox', false, false);
                        fancyBox.onload = function () {
                            fancyboxLoaded = true;
                        }
                    }

                    if (!LazyHelper.doesScriptExists(pardomFormJsUrl)) {
                        let scriptsLoadedTimer = setInterval(function () {
                            if (fancyboxLoaded && frameresizerLoaded) {
                                clearInterval(scriptsLoadedTimer);
                                loadPardotFormScript(clickedElement);
                            }
                        }, 100);
                    }
                });

                function loadPardotFormScript(clickedElement) {
                    let pardotForm = LazyHelper.addScriptFile(pardomFormJsUrl, 'pardot-form', false);

                    pardotForm.onload = function () {
                        // Create browser compatible event handler.
                        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                        var eventer = window[eventMethod];
                        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
                        // Listen for a message from the iframe.
                        eventer(messageEvent, function (e) {
                            if (isNaN(e.data)) return;

                            // replace iframe[id^="PardotForm"] with what ever what ever iframe id you need
                            var pardotForm = document.querySelector('iframe[id^="PardotForm"]');
                            if (pardotForm !== null) {
                                pardotForm.style.cssText = 'max-width: 100%; height: ' + e.data + 'px;';
                            }

                            var fancyBoxFrame = document.querySelector('iframe[id^="fancybox-frame"]');
                            if (fancyBoxFrame !== null) {
                                fancyBoxFrame.style.cssText = 'max-width: 100%;';
                            }
                        }, false);

                        setTimeout(function () {
                            clickedElement.click();
                        }, 100);
                    }
                }
            }
        });
    }
}

InitPardomForm.init();